import { ApplicationState } from '@app/store'
import {
  IGlobalConfigurationState,
  selectConfiguration,
} from '@app/store/modules/global'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { PreferencesModal } from '../components/PreferencesModal'
import {
  actionCreators,
  IPreferencesEditState,
  selectError,
  selectIsLoading,
  selectIsOpen,
  selectIsSaving,
  selectLandingPage,
} from '../modules/preferencesEdit'

export default connect(
  createStructuredSelector<
    ApplicationState,
    IPreferencesEditState & IGlobalConfigurationState
  >({
    configuration: selectConfiguration(),
    error: selectError(),
    isLoading: selectIsLoading(),
    isOpen: selectIsOpen(),
    isSaving: selectIsSaving(),
    landingPage: selectLandingPage(),
  }),
  actionCreators,
)(PreferencesModal)
